export { TextAreaGroup, TextAreaGroup as TextArea } from './InputGroup/text-area';
